import { makeAutoObservable, observable, toJS  } from "mobx";
import mainStore from "../../home/store/mainStore";
import { TargetService } from "../services/targetservice";
import { saveAs } from "file-saver";
import moment from "moment";
import { getCurrentUser } from "../../../Utility/modules/helpers";
class TargetStore {
  constructor() {
    makeAutoObservable(this);
  }

  sheetName = "Targets";
  disableCommand = true;
  targetYear = moment(new Date()).format("YYYY");

  isloading = false;
  importedTargets = [];
  showTargetDialog = false;
  isDownloadingTemplate = false;
  hasImported = false;
  isSaving = false;
  showEquityDialog = false;
  mainStore = mainStore;
  showTargetEditDialog = false;
  isSavingEquity = false;
  isSavingMonthlyTarget = false;
  targets = observable.map({});
  selRow = {};
  prompt = true;

  ondoShare = {};
  offShoreRoyalty = 18.5;
  onshoreRoyalty = 20;
  techAdjustment = 7;
  async loadTargetData() {
    const assetId = mainStore.assetContextId;
    this.importedTargets = [];
    this.hasImported = false;

    try {
      this.isloading = true;
      const res = await TargetService.getAssetTargetByYear(
        this.targetYear,
        assetId
      );
      this.targets.clear();
      res.targets.forEach((t) => {
        this.targets.set(t.targetId, t);
      });
      this.ondoShare = res.equity;
      const {
        technicalAdjustment,
        offShoreRoyalty,
        onshoreRoyalty,
      } = res.equity;
      this.techAdjustment = technicalAdjustment;
      this.offShoreRoyalty = offShoreRoyalty;
      this.onshoreRoyalty = onshoreRoyalty;
      console.log("equity", res.equity);
      this.prompt = res.prompt;
      return res.prompt;
    } catch (error) {
      throw error;
    } finally {
      this.isloading = false;
    }
  }

  async downloadTemplate() {
    try {
      this.isDownloadingTemplate = true;
      const res = await TargetService.downloadTargetTemplate(this.targetYear);
      saveAs(res, "target template.xlsx",{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    } catch (error) {
      throw error;
    } finally {
      this.isDownloadingTemplate = false;
    }
  }

  get importHasRows() {
    return this.importedTargets.length > 0;
  }

  async saveTargets() {
    const targets = [...this.importedTargets.values()];
    const assetId = mainStore.assetContextId;
    try {
      if (targets.length) {
        this.isSaving = true;
        const uploadedBy = getCurrentUser()?.fullName;
        await TargetService.saveTargets(
          targets,
          this.targetYear,
          uploadedBy,
          assetId
        );

        await this.loadTargetData();
      }
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }
  async saveMonthTarget() {
    try {
      this.isSavingMonthlyTarget = true;
      const uploadedBy = getCurrentUser()?.fullName;
      const retVal = await TargetService.saveMonthTarget(
        toJS(this.selRow),
        uploadedBy
      );
      return retVal;
    } catch (error) {
      throw error;
    }
  }
  async saveEquity() {
    try {
      this.isSavingEquity = true;
      const uploadedBy = getCurrentUser()?.fullName;
      const offShoreRoyalty =
        this.mainStore.assetContextId === 1 ? toJS(this.offShoreRoyalty) : 0;
      const onshoreRoyalty =
        this.mainStore.assetContextId === 1 ? toJS(this.onshoreRoyalty) : 0;
      const technicalAdjustment =
        this.mainStore.assetContextId === 1 ? toJS(this.techAdjustment) : 0;
      const retVal = await TargetService.saveEquity({
        ...this.ondoShare,
        offShoreRoyalty,
        onshoreRoyalty,
        technicalAdjustment,
        uploadedBy,
      });
      this.prompt = false;
      return retVal;
    } catch (error) {
      throw error;
    }
  }

  clearForm() {
    const initData = {
      ...toJS(this.selRow),
      comments: "",
      condensateTarget: 0,
      gastoPlant: 0,
      nglTarget: 0,
      oilProduced: 0,
      oilRecieved: 0,
      gasProduced: 0,
    };

    this.selRow = initData;
  }
}



const targetStore = new TargetStore();
export default targetStore; //createContext();

